(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buying-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', function(event) {
    const item = event.target.closest('.buying-accordion__item');
    if (item) item.open = true;
  });

  } catch(e) { console.error(e); }
})();
})();
